import { LineStyle, Color, LineKinds, ArrowKinds, Vector, Point } from "../../drawing";
import { AbstractVectorItem } from "./AbstractVectorItem";
import { ILineDrawable } from "./ILineDrawable";
import { IArrowDrawable } from "./IArrowDrawable";
import { TypeKeys } from "./TypeKeys";
import { IExpandable } from "./IExpandable";

export class LineItem extends AbstractVectorItem implements ILineDrawable, IArrowDrawable, IExpandable {
  constructor() {
    super(TypeKeys.LineItem);
  }

  public lineStyle: LineStyle = new LineStyle(new Color("#000000"), LineKinds.Normal, 2);
  public arrowKind: ArrowKinds = ArrowKinds.None;

  protected createCloneInstance(): LineItem {
    return new LineItem();
  }

  protected applyMembers(clone: LineItem): void {
    super.applyMembers(clone);
    clone.lineStyle = this.cloneValue(this.lineStyle);
    clone.arrowKind = this.cloneValue(this.arrowKind);
  }

  expandToBottom(value: number): void {
    const from = this.vector.from;
    const to = this.vector.to;
    if (from.y === to.y) { return; }
    this.vector = (from.y > to.y)
      ? new Vector(new Point(from.x, from.y + value), to)
      : new Vector(from, new Point(to.x, to.y + value));
  }
}
